import { create } from "zustand";
import {
    isSystem12HourFormat,
    getDateTimeFormat,
    getTimeFormat,
} from "utils/datetime";

interface DateTimeFormatState {
    is12HourFormat: boolean;
    dateTimeFormat: string;
    timeFormat: string;
    longDateTimeFormat: string;
    longTimeFormat: string;

    checkAndUpdateFormat: () => void;
}

export const useDateTimeFormatStore = create<DateTimeFormatState>(
    (set, get) => {
        const is12Hour = isSystem12HourFormat();

        return {
            is12HourFormat: is12Hour,
            dateTimeFormat: getDateTimeFormat(),
            timeFormat: getTimeFormat(),
            longDateTimeFormat: getDateTimeFormat(true),
            longTimeFormat: getTimeFormat(true),

            checkAndUpdateFormat: () => {
                const currentIs12Hour = isSystem12HourFormat();
                const storedIs12Hour = get().is12HourFormat;

                // Only update if format actually changed
                if (currentIs12Hour !== storedIs12Hour) {
                    set({
                        is12HourFormat: currentIs12Hour,
                        dateTimeFormat: getDateTimeFormat(),
                        timeFormat: getTimeFormat(),
                        longDateTimeFormat: getDateTimeFormat(true),
                        longTimeFormat: getTimeFormat(true),
                    });
                }
            },
        };
    }
);
